import { React, useCallback, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FreeMode, Pagination, Navigation } from "swiper";
import { SVGIcons, ImgIcons, Imgbanner } from "../../Helpers/Common";
import { Link } from "react-router-dom";
import { Showdetailspopup } from "../Showdetailspopup/Showdetailspopup";
import Hover from "../OnHoverDetails/Hover";

var SVGIcon = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));
var ImageData = "";
ImgIcons().then((result) => (ImageData = result));

export function Layout16(props) {
  const [showdetails, setshowdetails] = useState(false);
  const [details, setdetails] = useState(false);
  // const [showShimmer, setShowShimmer] = useState(true);

  // const handleTimeout = useCallback(() => {
  //   setShowShimmer(false);
  // }, []);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowShimmer(false);
  //   }, 1000);

  //   return () => {
  //     clearTimeout(timer);
  //   };
  // }, [handleTimeout]);

  function showdetailspop(data) {
    setshowdetails(true);
    setdetails(data);
  }

  const headerText = () => {
    return (
      <>
        {/* {showShimmer ? (
          <div className="line linehead linedesk" />
        ) : (
          <> </>
          )} */}
        <div className="head temp14-head">
          <h4>
            {props.title.display_title}
            <span className="red"> {props.title.display_title_sufix}</span>
          </h4>
          <p>{props.title.section_log_line}</p>
        </div>
      </>
    );
  };

  let Closepopup = () => {
    setshowdetails(false);
  };
  return (
    <>
      <section className="mb-0 dD-none">
        <div className="temp14 temp14-bay temp14-bay1">
          {headerText()}
          <div className="temp14-area">
            <Swiper
              slidesPerView={2.4}
              spaceBetween={16}
              freeMode={true}
              loop={false}
              loopFillGroupWithBlank={true}
              centeredSlides={false}
              breakpoints={{
                700: {
                  slidesPerView: 3.8,
                },
                850: {
                  slidesPerView: 6.3,
                },
              }}
              modules={[FreeMode, Pagination]}
              className="temp14-slider"
            >
              {props.Layout1.map((data, index) => {
                var GenereTitle = data.genres.split(",");
                GenereTitle = GenereTitle[0];
                if (data.premium && !data.original_tag) {
                  var premium = (
                    <img
                      src={props.silverIcon}
                      style={{
                        width: "1.3rem",
                        marginRight: "3px",
                        marginBottom: "2px",
                      }}
                    />
                  );
                }
                if (data.original_tag && data.premium) {
                  var original = (
                    <img
                      src={props.goldenIcon}
                      style={{
                        width: "1.3rem",
                        marginRight: "3px",
                        marginBottom: "2px",
                      }}
                    />
                  );
                }
                return (
                  <SwiperSlide key={index} className="temp14-item">
                    {/* {showShimmer ? (
                      <img src={ImageData["placeholder2.png"]} alt="shimmer" className="shimmer" />
                    ) : (
                      <>
                      </>
                    )} */}
                    <div
                      className="temp14-itemColor"
                      onClick={() => {
                        showdetailspop(data);
                      }}
                    >
                      <img src={data.vertical_banner.small} alt="DocuBay" />
                    </div>
                    <div className="bay-title">{GenereTitle}</div>
                    <div className="premium-red">
                      {premium}
                      {original}
                    </div>

                  </SwiperSlide>
                );
              })}
              <SwiperSlide></SwiperSlide>
            </Swiper>
          </div>
        </div>
      </section>
      <section className="mb-0 dD-block">
        <div className="temp14 temp14-bay temp14-bay1">
          {headerText()}
          <div className="temp14-area">
            <div className="side-overlay-L dD-block"></div>
            <div className="side-overlay-R dD-block"></div>
            <Swiper
              navigation={{
                prevEl: ".slick-prev",
                nextEl: ".slick-next",
              }}
              slidesPerView={2.4}
              spaceBetween={16}
              slidesPerGroup={5}
              freeMode={true}
              loop={false}
              loopFillGroupWithBlank={true}
              centeredSlides={false}
              breakpoints={{
                650: {
                  slidesPerView: 1,
                },
                850: {
                  slidesPerView: 6.4,
                },
              }}
              modules={[FreeMode, Pagination, Navigation]}
              className="temp14-slider"
            >
              <button
                className="slick-prev slick-arrow"
                type="button"
                aria-label="Previous"
              />
              {props.Layout1.map((data, index) => {
                var GenereTitle = data.genres.split(",");
                GenereTitle = GenereTitle[0];
                if (data.premium && !data.original_tag) {
                  var premium = (
                    <img
                      src={props.silverIcon}
                      style={{
                        width: "1.7rem",
                        marginRight: "3px",
                        marginBottom: "2px",
                      }}
                    />
                  );
                }
                if (data.original_tag && data.premium) {
                  var original = (
                    <img
                      src={props.goldenIcon}
                      style={{
                        width: "1.7rem",
                        marginRight: "3px",
                        marginBottom: "2px",
                      }}
                    />
                  );
                }
                return (
                  <SwiperSlide key={index} className="temp14-item">
                    {/* {showShimmer ? (
                      <img src={ImageData["placeholder2.png"]} alt="shimmer" className="shimmer" />
                    ) : (
                      <>
                            </>
                    )} */}
                    <Hover
                      data={data}
                      silverIcon={props.silverIcon}
                      goldenIcon={props.goldenIcon}
                    />
                    <div className="temp14-itemColor">
                      <img src={data.vertical_banner.small} alt="DocuBay" />
                    </div>
                    <div className="bay-title">{GenereTitle}</div>
                    <div className="premium-red">
                      {premium}
                      {original}
                    </div>
                  </SwiperSlide>
                );
              })}
              <SwiperSlide></SwiperSlide>
              <button
                className="slick-next slick-arrow"
                type="button"
                aria-label="Next"
              />
            </Swiper>
          </div>
        </div>
      </section>
      {showdetails ? (
        <Showdetailspopup
          data={details}
          Closebtn={Closepopup}
          silverIcon={props.silverIcon}
          goldenIcon={props.goldenIcon}
        />
      ) : null}
    </>
  );
}

export default Layout16;
